module.exports = __webpack_public_path__ + "img/ge.0f8a7acc.svg";